export function calculateSingleScores(data) {

  const { userSelect, influencerSpecs } = data

  const result = Object.keys(influencerSpecs[userSelect[0]]).reduce((acc, curr) => ({
    ...acc,
    [curr]: ((userSelect.map(key => influencerSpecs[key][curr]))
                        .reduce((previous, current) => current += previous))/userSelect.length,
  }), {});
  return result
}

export function calculateWeightedScores(data) {

  const goalWeight = 0.7
  const indWeight = 0.2
  const ageWeight = 0.1

  const nano =  (calculateSingleScores(data.goals).nano*goalWeight)+
                    (calculateSingleScores(data.industries).nano*indWeight)+
                    (calculateSingleScores(data.ageRanges).nano*ageWeight)

  const micro =     (calculateSingleScores(data.goals).micro*goalWeight)+
                    (calculateSingleScores(data.industries).micro*indWeight)+
                    (calculateSingleScores(data.ageRanges).micro*ageWeight)

  const macro =  (calculateSingleScores(data.goals).macro*goalWeight)+
                    (calculateSingleScores(data.industries).macro*indWeight)+
                    (calculateSingleScores(data.ageRanges).macro*ageWeight)

  const star =      (calculateSingleScores(data.goals).star*goalWeight)+
                    (calculateSingleScores(data.industries).star*indWeight)+
                    (calculateSingleScores(data.ageRanges).star*ageWeight)


  return (
    {nano, micro, macro, star}
  )
}

export function recommendation(data) {
  const scores = calculateWeightedScores(data)

  const sortedInfTypes = Object.keys(scores)
                               .sort(function(a,b){return scores[b]-scores[a]})

  const topOne = sortedInfTypes[0]
  const topTwo = sortedInfTypes[1]

  if (scores[topTwo] > 5) {
    return {topOne: topOne, topTwo: topTwo}
  } else {
    return {topOne: topOne, topTwo: false}
  }
}
